<template>
  <a href="#" class="nav-link" @click.prevent="$emit('click')">
    <icon-cart :width="width" :height="height" :rx="rx" :action="action" :loading="loading"></icon-cart>
  </a>
</template>

<script>
import IconCart from "@/components/interface/svg/IconCart.vue";
export default {
  name: "ButtonToggleCart",
  components: {IconCart},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      required: true
    },
     width: {
      required: false,
      type: Number
    },
    height: {
      required: false,
      type: Number
    },
    rx: {
      required: false,
      type: Number
    },
  }
}
</script>
